import { loggedOut } from '@/layouts'
import Login from '@/views/Login'

import { requiresAuth, logout } from '@/lib/auth.js'
import { tryHost } from '@/lib/api.js'

export default [ 
  {
    path: '/login',
    component: loggedOut,
    children: [
      {
        name: 'login',
        path: '',
        component: Login,    
      },
      {
        name: 'login/accept',
        path: 'accept',
        component: () => import('@/views/Login/Accept'),
      },
      {
        name: 'login/claim',
        path: 'claim/:id(\\d+)',
        props: true,
        component: () => import('@/views/Login/Claim'),
      },
      {
        name: 'login/eula',
        path: 'eula',
        component: () => import('@/views/Login/EULA'),
      },
      {
        name: 'login/privacy',
        path: 'privacy',
        component: () => import('@/views/Login/Privacy'),
      },
      {
        name: 'login/welcome',
        beforeEnter: requiresAuth,
        path: 'welcome',
        component: () => import('@/views/Login/Welcome'),
      },
    ]
  },
  { 
    path: '/qr',
    beforeEnter() { window.location.replace(tryHost()) }
  },
  { 
    path: '/link',
    beforeEnter() { window.location.replace(tryHost()) }
  },
  {
    path: '/recover',
    component: loggedOut,
    children: [
      {
        name: 'recover',
        path: '',
        component: () => import('@/views/Recover'),    
      },
      {
        name: 'recover/methods',
        path: 'methods',
        component: () => import('@/views/Recover/Methods'),
      },
      {
        name: 'recover/verify',
        path: 'verify',
        component: () => import('@/views/Recover/Verify'),
      },
      {
        path: 'verify/:id(\\d+)',
        props: true,
        component: () => import('@/views/Recover/Verify'),
      },
    ]
  },
  {
    name: 'logout',
    path: '/logout',
    beforeEnter: logout,
  },    
]